import "./payroll.css";
import React, { useCallback, useEffect, useState, useRef } from "react";
import ButtonCom from "../../components/button/button";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import { IoIosAdd } from "react-icons/io";
import { FiInfo } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonGetDataThird,
  initCommonState,
  commonSaveData,
} from "../../redux/slices/commonSlice";
import { Link, useNavigate } from "react-router-dom";
import {
  getAllowanceListPath,
  getDeductionListPath,
  getEmpPfVariableListPath,
  adminCreateSalaryTemplatePath,
  getCalendarMonthListPath,
} from "../../services/config";

const animatedComponents = makeAnimated();
const SalaryTemplate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);

  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;

  const [validated, setValidated] = useState(false);
  const [allowance] = useState([
    {
      value: 1,
      label: "Special Allowance",
    },
    {
      value: 2,
      label: "Dearness Allowance",
    },
    {
      value: 3,
      label: "Other Allowance",
    },

    {
      value: 4,
      label: "Add Allowance +",
    },
  ]);
  const [calendarMonthList, setCalendarMonthList] = useState([]);
  const [deductionApiList, setDeductionApiList] = useState([]);
  const [pfVariableList, setPfVariableList] = useState({});
  const [saveData, setSaveData] = useState({
    basicPay: "",
    basicPayType: "",
    hraPay: "",
    hraType: "",
    templateName: "",
    employerPf: "",
    employerESI:
      "0.35% on Gross Salary if the Gross Salary is less than Rs. 21,000",
    adminCharges: "",
    edliCharges: "",
    empPfChange: "",
    employeePf: "",
    employeeESI:
      "0.75% on Gross Salary if the Gross Salary is less than Rs. 21,000",
    professionalTax:
      "Max Rs. 200 will be deducted if the Gross Salary is 25000 or above",
    preEarnings: "",
    preAllowance: "",
  });

  const handleToggleChange = (event) => {
    setSaveData((pre) => ({
      ...pre,
      [event.target.name]: event.target.checked ? "Fixed" : "Percentage",
    }));
  };
  const [customEmpPF, setCustomEmpPF] = useState(false);
  const [earnings, setEarnings] = useState([]);
  const [deductions, setDeductions] = useState([]);
  
  // Modal states for adding custom allowance
  const [showAddAllowanceModal, setShowAddAllowanceModal] = useState(false);
  const [customAllowanceName, setCustomAllowanceName] = useState("");
  const [customAllowanceError, setCustomAllowanceError] = useState("");

  const getAllowance = useCallback(() => {
    dispatch(commonGetDataOne(getAllowanceListPath));
    dispatch(commonGetDataTwo(getDeductionListPath));
    dispatch(commonGetDataThird(getCalendarMonthListPath));
  }, []);

  useEffect(() => {
    getAllowance();
  }, []);

  // useEffect(() => {
  //   if (commonState.commonGetOneSuccess) {
  //     const newArr = commonState.commonGetOneData?.map((row) => {
  //       return { value: row.allowanceId, label: row.allowance_name };
  //     });
  //     setAllowance(newArr);
  //     dispatch(initCommonState());;
  //   }
  // }, [commonState.commonGetOneSuccess]);

  useEffect(() => {
    if (commonState.commonGetTwoSuccess) {
      const newArr = commonState.commonGetTwoData?.map((row) => {
        return { value: row.deductionId, label: row.deduction_name };
      });
      // setDeductionApiList(newArr);
    }
  }, [commonState.commonGetTwoSuccess]);

  const getPfVariable = useCallback(() => {
    dispatch(commonGetData(`${getEmpPfVariableListPath}${user?.user_id}`));
  }, []);

  useEffect(() => {
    getPfVariable();
  }, []);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setPfVariableList(commonState.commonGetData[0]);
    }
    if (commonState.commonGetThirdSuccess) {
      setCalendarMonthList(commonState.commonGetThirdData);
    }
  }, [commonState]);

  // const addEarningsField = (e) => {
  //   const { value, label } = e;
  //   if (value == 4) {
  //     setIsPreEarnings(true);
  //     setEarnings([
  //       ...earnings,
  //       {
  //         id: value,
  //         head: "",
  //         calculation: "",
  //         calculationType: "",
  //       },
  //     ]);
  //   } else {
  //     const isPresent = earnings.some((earning) => earning.id === value);
  //     if (!isPresent) {
  //       setEarnings([
  //         ...earnings,
  //         {
  //           id: value,
  //           head: label,
  //           calculation: "",
  //           calculationType: "",
  //         },
  //       ]);
  //       setIsPreEarnings(false);
  //     }
  //   }
  // };

  const addEarningsField = (e) => {
    const { value, label } = e;

    setEarnings((prevEarnings) => {
      if (value === 4) {
        // Open modal instead of adding inline
        setShowAddAllowanceModal(true);
        return prevEarnings;
      }

      const isPresent = prevEarnings.some((earning) => earning.id === value);
      if (!isPresent) {
        return [
          ...prevEarnings,
          { id: value, head: label, calculation: "", calculationType: "" },
        ];
      }

      return prevEarnings;
    });
  };

  // Handle adding custom allowance from modal
  const handleAddCustomAllowance = () => {
    if (!customAllowanceName.trim()) {
      setCustomAllowanceError("Allowance name is required");
      return;
    }

    setEarnings((prevEarnings) => [
      ...prevEarnings,
      { id: Date.now(), head: customAllowanceName, calculation: "", calculationType: "" },
    ]);

    // Reset and close modal
    setCustomAllowanceName("");
    setCustomAllowanceError("");
    setShowAddAllowanceModal(false);
  };

  const handleCloseAllowanceModal = () => {
    setCustomAllowanceName("");
    setCustomAllowanceError("");
    setShowAddAllowanceModal(false);
  };

  const updateEarnings = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index].head = value;
    setEarnings(list);
  };

  const removeEarningsFields = (e, index) => {
    e.preventDefault();
    const rows = [...earnings];
    rows.splice(index, 1);
    setEarnings(rows);
  };

  const handleEarningsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index][name] = value;
    setEarnings(list);
  };

  const handleEarningsRadioChanges = (index, e) => {
    const list = [...earnings];
    list[index].calculationType = e.target.checked ? "Fixed" : "Percentage";
    setEarnings(list);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (value == "Custom") {
      setCustomEmpPF(true);
      setSaveData((pre) => ({
        ...pre,
        [name]: value,
      }));
    } else {
      setCustomEmpPF(false);
      setSaveData((pre) => ({
        ...pre,
        [name]: value,
        empPfChange: "",
      }));
    }
  };

  const handleEmployerChange = (e) => {
    const { value, name } = e.target;
    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleEmpPfChange = (e) => {
    const { value, name } = e.target;
    if (value <= 2000) {
      setSaveData((pre) => ({
        ...pre,
        empPfChange: value,
      }));
    }
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setSaveData((pre) => ({
      ...pre,
      [name]: checked ? "1" : "0",
    }));
  };

  const addDeductionsField = (e) => {
    const { value, label } = e;
    // const isPresent = deductions.some((deduction) => deduction.id === value);
    // if (!isPresent) {
    setDeductions([
      ...deductions,
      {
        id: deductions.length + 1,
        head: label,
        calculation: "",
        calculationType: "",
      },
    ]);
    // }
  };

  const removeDeductionsFields = (e, index) => {
    e.preventDefault();
    const rows = [...deductions];
    rows.splice(index, 1);
    setDeductions(rows);
  };

  const handleDeductionsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...deductions];
    if (list[index].calculationType == "Percentage") {
      if (value <= 100) {
        list[index][name] = value;
        setDeductions(list);
      }
    } else {
      list[index][name] = value;
      setDeductions(list);
    }
  };

  const updateDeductions = (index, e) => {
    const { value } = e.target;
    const list = [...deductions];
    list[index].head = value;
    setDeductions(list);
  };

  const handleDeductionsRadioChanges = (index, e) => {
    const list = [...deductions];
    list[index].calculationType = e.target.checked ? "Fixed" : "Percentage";
    setDeductions(list);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [calendarType, setCalendarType] = useState("");

  const dropdownFunc = () => {
    setIsOpen((prev) => !prev);
  };

  const handleCalendarMonthList = (id, name) => {
    setCalendarType(name);
    document.querySelector(".selected-display").innerHTML = name;
  };

  const handleStartDate = (e) => {
    let { value } = e.target;
    if (value == 1) {
      document.querySelector(".end-date").value = 31;
    } else {
      document.querySelector(".end-date").value = value - 1;
    }
  };

  const preSubmit = () => {
    document.getElementById("submitForm").click();
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      const allowanceList = earnings.map((v) => {
        return {
          [v.head]: v.calculation + "|" + v.calculationType,
        };
      });

      const newAllowanceList = deductions.map((v) => {
        return {
          [v.head]: v.calculation + "|" + v.calculationType,
        };
      });

      let d = {
        path: adminCreateSalaryTemplatePath,
        data: {
          userId: user.user_id,
          payrollModelName: saveData.templateName,
          basicPay: saveData.basicPay + "|" + saveData.basicPayType,
          hraPay: saveData.hraPay + "|" + saveData.hraType,
          employerPf: saveData.employerPf,
          employerESI: saveData.employerESI,
          edliCharges: saveData.edliCharges,
          adminCharges: saveData.adminCharges,
          employeePf: saveData.empPfChange
            ? "3|" + saveData.empPfChange
            : saveData.employeePf,
          employeeESI: saveData.employeeESI,
          allowanceList,
          newAllowanceList,
        },
      };
      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess || commonState.commonError) {
      commonState.commonSuccess
        ? toast.success(commonState.commonMessage)
        : toast.error(commonState.commonMessage);
      dispatch(initCommonState());
      setTimeout(() => {
        navigate("/payroll-model");
      }, 1000);
    }
  }, [commonState]);

  return (
    <div className="body-container">
      <div className="page-top-bar" style={{ height: "70px" }}>
        <div
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItem: "center",
              justifyContent: "start",
              gap: "10px",
              top: "10px",
            }}
          >
            <Link to={"/payroll-model"}>
              <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
            </Link>
            <h1 style={{ fontSize: "20px", fontWeight: "400" }}>
              Payroll Model
            </h1>
          </div>

          <ButtonCom
            type={"button"}
            class_name={"p_btn"}
            text="Save Model"
            url_or_onclick={preSubmit}
            icon={null}
            width={""}
          />
        </div>
      </div>

      <div
        className="page-body p-5"
        style={{ position: "relative", height: "100%", maxHeight: "auto" }}
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          style={{ width: "60%", margin: "0 auto" }}
        >
          <div
            style={{
              paddingBottom: "0px",
            }}
          >
            <Row className="display-center">
              <Col sm="5">
                <Form.Label style={{ whiteSpace: "nowrap" }}>
                  <strong>Model Name</strong>
                </Form.Label>
              </Col>
              <Col sm="7">
                <Form.Control
                  name="templateName"
                  value={saveData.templateName}
                  onChange={handleChange}
                  placeholder="Model name"
                  required
                />
              </Col>
            </Row>

            <Row className="mt-2 display-center">
              <Col sm="5">
                <label style={{ position: "relative", top: "-2px" }}>
                  Calendar Month
                </label>
              </Col>
              <Col sm="7" style={{ paddingRight: 11 }}>
                <div
                  className={`wrapper_dropdown ${isOpen ? "active" : null} `}
                  id="dropdown"
                  onClick={dropdownFunc}
                  style={{
                    minHeight: "39px",
                    borderRadius: "5px",
                  }}
                >
                  <span
                    className="selected-display"
                    id="destination"
                    style={{ color: "gray", position: "relative", top: "-2px" }}
                  >
                    Select calendar month
                  </span>
                  <svg
                    id="drp-arrow"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="arrow transition-all ml-auto rotate-180"
                    style={{ position: "relative", top: "-2px" }}
                  >
                    <path
                      d="M7 14.5l5-5 5 5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>

                  {isOpen && (
                    <ul className="dropdown">
                      {Array.isArray(calendarMonthList) &&
                        calendarMonthList.map((row, idx) => {
                          return (
                            <li
                              className="item"
                              key={idx}
                              style={{
                                borderBottom: "1px solid lightgray",
                              }}
                              onClick={() =>
                                handleCalendarMonthList(
                                  row.calendarId,
                                  row.month_name
                                )
                              }
                            >
                              <div>{row.month_name} </div>
                              <div
                                style={{
                                  marginTop: "-30px",
                                  fontSize: "12px",
                                  color: "gray",
                                }}
                              >
                                {row.month_subtext}
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </div>
              </Col>
            </Row>
            {
              (calendarType != "Calendar Month" && (
                <Row className="mt-2 display-center">
                  <Col sm="5">
                    <label style={{ whiteSpace: "nowrap" }}>Start Date</label>
                  </Col>
                  <Col
                    sm="7"
                    style={{
                      paddingRight: 11,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <p> from</p>
                    {(() => {
                      const rows = [];
                      for (let i = 1; i < 32; i++) {
                        rows.push(
                          <option value={i} key={i}>
                            {i}
                          </option>
                        );
                      }

                      return (
                        <Form.Select
                          // id="width-70-px"
                          onChange={handleStartDate}
                          style={{ color: "gray" }}
                        >
                          {rows}
                        </Form.Select>
                      );
                    })()}

                    <p> to</p>

                    <Form.Control
                      placeholder="0"
                      // id="width-70-px"
                      className="end-date"
                      value={31}
                      readOnly
                    />
                  </Col>
                </Row>
              ))
            }
          </div>

          <Row className="display-center">
            <Col className="" sm="5">
              <strong>Basics</strong>
            </Col>
            <Col
              sm="7"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <Form.Group
                className="mt-2"
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <Switch
                  name="basicPayType"
                  checked={saveData.basicPayType == "Fixed" ? true : false}
                  onChange={handleToggleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />

                {/* <Form.Check
                  type="radio"
                  name={"basicPayType"}
                  value="Fixed"
                  onChange={handleChange}
                  checked={saveData.basicPayType == "Fixed" ? "checked" : ""}
                  label="Fixed"
                  required
                />
                <Form.Check
                  type="radio"
                  name={"basicPayType"}
                  value="Percentage"
                  onChange={handleChange}
                  checked={
                    saveData.basicPayType == "Percentage" ? "checked" : ""
                  }
                  label="Percentage"
                  required
                />
                 */}

                <Form.Control
                  type="number"
                  name="basicPay"
                  value={saveData.basicPay}
                  onChange={handleChange}
                  style={{ color: "gray" }}
                  placeholder={`Enter basic ${
                    saveData.basicPayType == "Fixed"
                      ? " fixed amount"
                      : "percentage"
                  }`}
                  required
                />
                {saveData.basicPayType !== "Fixed" && (
                  <span className="input-icon">%</span>
                )}
              </Form.Group>
            </Col>
          </Row>

          {earnings.map((data, index) => {
            const { id, head, calculation, calculationType } = data;
            return (
              id == "2" && (
                <Row className="display-center" key={index}>
                  <Col className="" sm="5">
                    {id == 4 ? (
                      <Form.Control
                        onChange={(e) => updateEarnings(index, e)}
                        value={head}
                        placeholder="Enter allowance"
                        required
                        style={{ width: "235px" }}
                      />
                    ) : (
                      <strong>{head}</strong>
                    )}
                  </Col>

                  <Col
                    sm="7"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <Form.Group
                      className="mt-2"
                      style={{
                        position: "relative",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <Switch
                        name="calculationType"
                        checked={calculationType == "Fixed" ? true : false}
                        onChange={(e) => handleEarningsRadioChanges(index, e)}
                        inputProps={{ "aria-label": "controlled" }}
                      />

                      <Form.Control
                        type="number"
                        name="calculation"
                        value={calculation}
                        onChange={(e) => handleEarningsChanges(index, e)}
                        placeholder={`Enter ${
                          calculationType == "Fixed"
                            ? "fixed amount"
                            : "percentage"
                        }`}
                        style={{ color: "gray" }}
                        required
                      />
                      {calculationType !== "Fixed" && (
                        <span className="input-icon">%</span>
                      )}
                    </Form.Group>

                    <RiDeleteBin5Line
                      className="remove-icon"
                      onClick={(e) => removeEarningsFields(e, index)}
                      style={{ cursor: "pointer" }}
                    />
                  </Col>
                </Row>
              )
            );
          })}

          <Row className="display-center">
            <Col className="" sm="5">
              <strong>HRA</strong>
            </Col>
            <Col
              sm="7"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <Form.Group
                className="mt-2"
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <Switch
                  name="hraType"
                  checked={saveData.hraType == "Fixed" ? true : false}
                  onChange={handleToggleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
                {/* <Form.Check
                  type="radio"
                  name={"hraType"}
                  value="Fixed"
                  onChange={handleChange}
                  checked={saveData.hraType == "Fixed" ? "checked" : ""}
                  label="Fixed"
                  required
                />
                <Form.Check
                  type="radio"
                  name={"hraType"}
                  value="Percentage"
                  onChange={handleChange}
                  checked={saveData.hraType == "Percentage" ? "checked" : ""}
                  label="Percentage"
                  required
                /> */}

                <Form.Control
                  type="number"
                  name="hraPay"
                  value={saveData.hraPay}
                  onChange={handleChange}
                  style={{ color: "gray" }}
                  placeholder={`Enter hra ${
                    saveData.hraType == "Fixed" ? " fixed amount" : "percentage"
                  }`}
                  required
                  className="custom-input"
                />

                {saveData.hraType !== "Fixed" && (
                  <span className="input-icon">%</span>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* <Row className="mt-2">
            <Col sm="12" className="text-bold">
              Allowance
            </Col>
          </Row> */}

          {earnings.map((data, index) => {
            const { id, head, calculation, calculationType } = data;
            return (
              id != "2" && (
                <Row className="display-center" key={index}>
                  <Col className="" sm="5">
                    {id == 4 ? (
                      <Form.Control
                        onChange={(e) => updateEarnings(index, e)}
                        value={head}
                        placeholder="Enter allowance"
                        required
                        style={{ width: "235px" }}
                      />
                    ) : (
                      <strong>{head}</strong>
                    )}
                  </Col>

                  <Col
                    sm="7"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <Form.Group
                      className="mt-2"
                      style={{
                        position: "relative",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <Switch
                        name="calculationType"
                        checked={calculationType == "Fixed" ? true : false}
                        onChange={(e) => handleEarningsRadioChanges(index, e)}
                        inputProps={{ "aria-label": "controlled" }}
                      />

                      {/* <Form.Check
                      type="radio"
                      name={"calculationType-" + index}
                      value="Fixed"
                      onChange={(e) => handleEarningsRadioChanges(index, e)}
                      label="Fixed"
                      required
                    />
                    <Form.Check
                      type="radio"
                      name={"calculationType-" + index}
                      value="Percentage"
                      onChange={(e) => handleEarningsRadioChanges(index, e)}
                      label="Percentage"
                      required
                    /> */}

                      <Form.Control
                        type="number"
                        name="calculation"
                        value={calculation}
                        onChange={(e) => handleEarningsChanges(index, e)}
                        placeholder={`Enter ${
                          calculationType == "Fixed"
                            ? "fixed amount"
                            : "percentage"
                        }`}
                        style={{ color: "gray" }}
                        required
                      />
                      {calculationType !== "Fixed" && (
                        <span className="input-icon">%</span>
                      )}
                    </Form.Group>

                    <RiDeleteBin5Line
                      className="remove-icon"
                      onClick={(e) => removeEarningsFields(e, index)}
                      style={{ cursor: "pointer" }}
                    />
                  </Col>
                </Row>
              )
            );
          })}
          {/* Add allowance */}
          <Row className="mt-2">
            <Col className="remove title-flex" sm="4">
              <FormControl style={{ width: "100%" }} required>
                <Select
                  value={"Add Allowance"}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  options={allowance}
                  onChange={addEarningsField}
                  placeholder={
                    <div
                      className="add-text"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IoIosAdd className="add-icon" /> Add Allowance
                    </div>
                  }
                  style={{ border: "none" }}
                />
              </FormControl>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col sm="5" className="text-bold">
              <strong>Employee Contributions</strong>
            </Col>
            <Col sm="7" className="text-bold">
              Select Components
            </Col>
          </Row>

          <Row className="mt-4 display-center">
            <Col className="" sm="5">
              <strong>Employee PF</strong>
            </Col>
            <Col sm="7">
              <Form.Group>
                <Form.Select
                  name="employeePf"
                  value={saveData.employeePf}
                  style={{ width: "100%" }}
                  onChange={handleChange}
                  required={customEmpPF ? false : true}
                >
                  <option value="">Select PF</option>
                  <option value="1">12% on Basic Salary Max Rs. 1800</option>
                  <option value="2">
                    12% on Basic + DA Salary Max Rs. 1800
                  </option>
                  <option
                    value="Custom"
                    selected={customEmpPF ? "selected" : null}
                  >
                    Custom
                  </option>
                  {/* <option value={pfVariableList.pf_limit}>
                    {pfVariableList.pf_limit} &#8377;
                  </option>
                  <option value={pfVariableList.pf_variable}>
                    {pfVariableList.pf_variable} %
                  </option> */}
                </Form.Select>

                {customEmpPF ? (
                  <Form.Control
                    className="mt-2"
                    name="employeePf"
                    value={saveData.empPfChange}
                    style={{ width: "100%" }}
                    onChange={handleEmpPfChange}
                    required
                    placeholder="Enter custom PF amount"
                  />
                ) : null}
              </Form.Group>
            </Col>
          </Row>

          {/* Deductions --------------------------------------------------------- */}

          <Row className="mt-2 display-center">
            <Col className="" sm="5">
              <strong>Employee ESI</strong>
            </Col>
            <Col sm="7">
              <Form.Group>
                <p
                  name="employeeESI"
                  style={{
                    width: "100%",
                    textWrap: "wrap",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px",
                    color: "gray",
                  }}
                >
                  {saveData.employeeESI}
                </p>
                {/* <FormControl style={{ width: "100%" }} required>
                  <Form.Select
                    name="employeeESI"
                    value={saveData.employeeESI}
                    style={{ width: "100%" }}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select ESI</option>
                    <option value={pfVariableList.employee_esi_variable}>
                      {pfVariableList.employee_esi_variable} %
                    </option>
                  </Form.Select>
                </FormControl> */}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2 display-center">
            <Col className="" sm="5">
              <strong>Professional TAX</strong>
            </Col>
            <Col sm="7">
              <Form.Group>
                <p
                  name="professionalTax"
                  style={{
                    width: "100%",
                    textWrap: "wrap",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px",
                    color: "gray",
                  }}
                >
                  {saveData.professionalTax}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col className="" sm="5">
              <strong>TDS</strong>
            </Col>
            <Col sm="7">
              <Form.Group className="">
                System Calculated <FiInfo className="info-icon" />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col sm="5" className="text-bold">
              <strong>Employer Contributions</strong>
            </Col>
          </Row>

          <Row className="mt-4 display-center">
            <Col className="" sm="5">
              <strong>Employer PF</strong>
            </Col>
            <Col sm="7">
              <Form.Group>
                <Form.Select
                  name="employerPf"
                  value={saveData.employerPf}
                  style={{ width: "100%" }}
                  onChange={handleEmployerChange}
                  required
                >
                  <option value="">Select PF</option>
                  <option value="1">12% on Basic Salary Max Rs. 1800</option>
                  <option value="2">
                    12% on Basic + DA Salary Max Rs. 1800
                  </option>
                  {/* <option value={pfVariableList.pf_limit}>
                    <span>{pfVariableList.pf_limit} &#8377;</span>
                  </option>
                  <option value={pfVariableList.pf_variable}>
                    {pfVariableList.pf_variable} %
                  </option> */}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2 display-center">
            <Col className="" sm="5">
              <strong>Employer ESI</strong>
            </Col>
            <Col sm="7">
              <Form.Group>
                <p
                  name="employerESI"
                  style={{
                    width: "100%",
                    textWrap: "wrap",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    padding: "5px",
                    color: "gray",
                  }}
                >
                  {saveData.employerESI}
                </p>
                {/* <Form.Select
                  name="employerESI"
                  value={saveData.employerESI}
                  style={{ width: "100%" }}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select ESI</option>
                  <option value={pfVariableList.esi_variable}>
                    {pfVariableList.esi_variable} %
                  </option>
                </Form.Select> */}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2 display-center">
            <Col className="" sm="5">
              <strong>EDLI Charges</strong>
            </Col>
            <Col sm="7">
              <Form.Group className="">
                <input
                  name="edliCharges"
                  value={saveData.edliCharges}
                  onChange={handleCheckbox}
                  type="checkbox"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                  checked={saveData.edliCharges == "1" ? "checked" : null}
                />
                {/* {validated && (
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    PF EDLI & Admin Charges is required   
                  </span>
                )} */}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2 display-center">
            <Col className="" sm="5">
              <strong>Admin Charges</strong>
            </Col>
            <Col sm="7">
              <Form.Group className="">
                <input
                  name="adminCharges"
                  value={saveData.adminCharges}
                  onChange={handleCheckbox}
                  type="checkbox"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                  checked={saveData.adminCharges == "1" ? "checked" : null}
                />
                {/* {validated && (
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    PF EDLI & Admin Charges is required  edliCharges adminCharges
                  </span>
                )} */}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col sm="12" className="text-bold">
              <strong>Allowance</strong>
            </Col>
          </Row>

          {deductions?.map((data, index) => {
            const { head, calculation, calculationType } = data;
            return (
              <Row className="mt-2  display-center" key={index}>
                <Col className="" sm="5">
                  <Form.Control
                    onChange={(e) => updateDeductions(index, e)}
                    value={head}
                    placeholder="Enter allowance"
                    required
                    style={{ width: "235px" }}
                  />
                </Col>
                <Col
                  sm="7"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Form.Group
                    style={{
                      position: "relative",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "5px",
                    }}
                  >
                    <Switch
                      name="calculationType"
                      checked={calculationType == "Fixed" ? true : false}
                      onChange={(e) => handleDeductionsRadioChanges(index, e)}
                      inputProps={{ "aria-label": "controlled" }}
                    />

                    {/* <Form.Check
                      type="radio"
                      name={"deductCalculationType-" + index}
                      value="Fixed"
                      onChange={(e) => handleDeductionsRadioChanges(index, e)}
                      label={`Fixed`}
                      required
                    />
                    <Form.Check
                      type="radio"
                      name={"deductCalculationType-" + index}
                      value="Percentage"
                      onChange={(e) => handleDeductionsRadioChanges(index, e)}
                      label="Percentage"
                      required
                    /> */}

                    <Form.Control
                      type="number"
                      name="calculation"
                      value={calculation}
                      placeholder={`Enter ${
                        calculationType == "Fixed"
                          ? "fixed amount"
                          : "percentage"
                      }`}
                      onChange={(e) => handleDeductionsChanges(index, e)}
                      style={{ color: "gray" }}
                      required
                    />

                    {calculationType !== "Fixed" && (
                      <span className="input-icon">%</span>
                    )}
                  </Form.Group>
                  <RiDeleteBin5Line
                    className="remove-icon"
                    onClick={(e) => removeDeductionsFields(e, index)}
                    style={{ cursor: "pointer" }}
                  />
                </Col>
              </Row>
            );
          })}

          <Row className="mt-2">
            <Col className="remove title-flex" sm="4">
              <FormControl style={{ width: "100%" }} required>
                <Button
                  type="button"
                  onClick={addDeductionsField}
                  style={{
                    backgroundColor: "#fff",
                    color: "skybule",
                    border: "1px solid lightgray",
                    borderRadius: "4px",
                  }}
                >
                  <div
                    className="add-text"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <IoIosAdd className="add-icon" /> Add Allowance
                  </div>
                </Button>
                {/* <Select
                  value={"Add Allowance"}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  options={deductionApiList}
                  onChange={addDeductionsField}
                  placeholder={
                    <div
                      className="add-text"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IoIosAdd className="add-icon" /> Add Allowance
                    </div>
                  }
                  style={{ border: "none" }}
                /> */}
              </FormControl>
            </Col>
          </Row>
          <button
            type="submit"
            id="submitForm"
            style={{ display: "none" }}
          ></button>
          <button
            type="submit"
            id="submitForm"
            style={{ display: "none" }}
          ></button>
        </Form>
      </div>

      {/* Modal for Adding Custom Allowance */}
      <Modal show={showAddAllowanceModal} onHide={handleCloseAllowanceModal} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Add Custom Allowance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Allowance Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter allowance name (e.g., Special Bonus, Performance Allowance)"
                value={customAllowanceName}
                onChange={(e) => {
                  setCustomAllowanceName(e.target.value);
                  setCustomAllowanceError("");
                }}
                isInvalid={!!customAllowanceError}
              />
              <Form.Control.Feedback type="invalid">
                {customAllowanceError}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAllowanceModal}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleAddCustomAllowance}
            style={{
              background: "linear-gradient(135deg, #8660F8 0%, #5b3fd4 100%)",
              border: "none",
            }}
          >
            Add Allowance
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default SalaryTemplate;
